import type { BaseEntity, FieldValue, SimpleFieldConfig } from "../types";

export interface MobileDetailModalFieldEqualityProps<T extends BaseEntity> {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  value: FieldValue;
  item: T;
  editedValue: FieldValue;
  isEditing: boolean;
  isFieldEditing: boolean;
  canEdit: boolean;
  roleName?: string;
  onEdit: (fieldId: string) => void;
  onSave: (fieldId: string) => Promise<void>;
  onCancel: () => void;
  onValueChange: (fieldId: string, newValue: any) => void;
}

function valuesEqual(prev: FieldValue, next: FieldValue): boolean {
  if (typeof prev === "object" && typeof next === "object") {
    return JSON.stringify(prev) === JSON.stringify(next);
  }
  return prev === next;
}

/**
 * Only re-render the field when its own value, editing state, or callbacks change.
 * Prevents re-renders triggered by sibling fields being edited.
 */
export function areMobileDetailModalFieldPropsEqual<T extends BaseEntity>(
  prev: MobileDetailModalFieldEqualityProps<T>,
  next: MobileDetailModalFieldEqualityProps<T>
): boolean {
  if (prev.fieldId !== next.fieldId) return false;
  if (prev.fieldConfig !== next.fieldConfig) return false;
  if (prev.isFieldEditing !== next.isFieldEditing) return false;
  if (prev.canEdit !== next.canEdit) return false;
  if (prev.roleName !== next.roleName) return false;
  if (!valuesEqual(prev.value, next.value)) return false;
  if (!valuesEqual(prev.editedValue, next.editedValue)) return false;
  if (
    prev.onEdit !== next.onEdit ||
    prev.onSave !== next.onSave ||
    prev.onCancel !== next.onCancel ||
    prev.onValueChange !== next.onValueChange
  ) {
    return false;
  }
  return true;
}
